﻿(function ($) {
    $.fn.sortDropDown = function (options) {

        var settings = $.extend({
            sortOptions: null,
            sortTable: null,
            headerIndex: null,
            sortCallback: function (header, sortValue) {
                // Does nothing
                void (sortValue);
            }
        }, options);

        return this.each(function () {

            var header = $(this);
            var headerSort = header.append("<div class='sort'></div>");

            function displaySortOptions() {

                var sortBox = header.find($(".sortDropDown"));

                if (sortBox.length > 0) {
                    sortBox.show();
                }
                else {
                    var sortList = "<div class='sortDropDown'><ul>";
                    jQuery.each(settings.sortOptions, function (i, val) {
                        sortList = sortList + "<li class='sortItem' data-id='" + i + "'>" + val + "<span></span></li>";
                    });
                    sortList = sortList + "</ul></div>";

                    $(headerSort).append(sortList);

                    $(".sortItem").click(function () {

                        sortBox = header.find($(".sortDropDown"));

                        var sortItems = sortBox.find($(".sortItem span"));
                        sortItems.removeAttr("class").html("");


                        var span = $(this).find("span");
                        if (span != null) {
                            span.attr("class", "selected");
                            span.html("&#10003;");
                        }

                        sortBox.hide();
                        $(header).change();
                    });
                }
            }


            $(header).change(function () {
                var selectedSort = header.find("span.selected");
                var sortId = selectedSort.parent().data("id");

                var tableElem = settings.sortTable[0];

                // If there's a tablesorter config, trigger the update event
                if (tableElem.config) {
                    tableElem.config.headers[settings.headerIndex] = { sorter: sortId };
                    settings.sortTable.trigger("update");
                }

                settings.sortCallback(header, sortId);
            });


            $(header).hover(function () {
                displaySortOptions();
            }, function () {
                var sortBox = header.find($(".sortDropDown"));
                sortBox.hide();
            });

            $(document).click(function (e) {
                var target = e.target;

                if (!$(target).is(headerSort)) {
                    $('.sortDropDown').hide();
                }
            });


        });
    };
}(jQuery));



//////////////////
// WEBPACK FOOTER
// ./Scripts/sortDropDown.js
// module id = 555
// module chunks = 0